import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { RejectReasonAdvancedForm } from 'domains/RejectReason/components'
import { useGetRejectReasonInitialValues } from 'domains/RejectReason/hooks'

const RejectReasonEditPage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()
  /* Getting params from router */
  const params = useParams()
  /* Getting id from params */
  const { rejectReasonId } = params

  /* Fetching page initial values */
  const [initialValues, loading] =
    useGetRejectReasonInitialValues(rejectReasonId)

  /* Configuring page header */
  const headingProps = {
    title: t('Reject reason edit'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Function to handle back click */
  const handleBack = () => history.goBack()

  return (
    <PageWrapper
      onBack={handleBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('Reject reason loading')} />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <RejectReasonAdvancedForm
              initialData={initialValues}
              showTitle={false}
            />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default RejectReasonEditPage
